<template>
  <v-dialog :value="value" persistent @click:outside="close" max-width="900px">
    <v-card>
      <div class="px-6 py-4">
        <h4>График погашения</h4>
        <v-btn class="mt-n7" icon absolute right small @click="close">
          <v-icon small>fas fa-times</v-icon>
        </v-btn>
      </div>
      <v-card-text>
        <v-simple-table class="white-space-no-wrap">
          <thead>
          <tr>
            <th>Месяц</th>
            <th>Cумма</th>
            <th>Процент</th>
            <th>Общее</th>
          </tr>
          </thead>
          <tbody>
          <tr
            :key="`item-${index}`"
            v-for="(item, index) in data">
            <td>{{item.payment_date}}</td>
            <td>{{item.main_residue|money}}</td>
            <td>{{item.percent_residue|money}}</td>
            <td>{{Math.ceil(item.main_residue + item.percent_residue) |money}}</td>
          </tr>
          <tr>
            <td><b>Всего:</b></td>
            <td><b>{{Math.ceil(all.main_residue)|money}}</b></td>
            <td><b>{{Math.ceil(all.percent_residue)|money}}</b></td>
            <td><b>{{Math.ceil(all.all)|money}}</b></td>
          </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>


<script>
  export default {
    name: 'payment-graph',
    props: {
      value: Boolean,
      data: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      all() {
        return this.data.reduce((obj, item) => {
          if (item.main_residue) {
            obj.main_residue += item.main_residue
            obj.all += item.main_residue
          }
          if (item.percent_residue) {
            obj.percent_residue += item.percent_residue
            obj.all += item.percent_residue
          }
          return obj
        }, {
          main_residue: 0,
          percent_residue: 0,
          all: 0
        })
      }
    },
    methods: {
      close() {
        this.$emit('input', false)
      }
    }
  }
</script>
